import { FC } from 'react'
import InlineSvg from 'react-inlinesvg'
import { observer } from 'mobx-react-lite'
import { PrismicRichText } from '@prismicio/react'
import { LinkField } from '@prismicio/client'
import tw from 'twin.macro'
import { Body, Grid, SubHeader } from '../UI'
import PrismicLinkInternalOrExternal from '../PrismicLinkInternalOrExternal'
import { theme } from '../../../tailwind.config'
import { RichTextFields } from '../../types/prismic'

import ctaArrow from '../../images/icons/cta-arrow.svg'
import { richTextStrongComponent } from '../../utils/richTextComponents'

type Props = {
  header: string
  subhead: RichTextFields
  ctas: Array<{
    cta_text: string
    cta_link: LinkField
  }>
  background_color: 'gb-blue' | 'gb-red' | 'gb-magenta'
  pagePath: string
  pageTitle: string
}

const GetStarted: FC<Props> = ({
  header,
  subhead,
  ctas,
  background_color = 'gb-magenta',
  pagePath,
  pageTitle,
}) => {
  const bgColor = theme.extend.colors[background_color]
  const hoverColor = theme.extend.colors[`${background_color}-dark`]

  return (
    <section
      css={[
        { backgroundColor: bgColor },
        tw`pt-[58px] pb-[76px] text-white font-domaine`,
      ]}
    >
      <Grid>
        <div tw="col-span-full text-center">
          <h2 css={[Body, tw`mb-[8px] lg:mb-[8px]`]}>{header}</h2>
        </div>
        <div tw="mb-[42px] col-span-full lg:mb-[49px] text-center">
          <h3 css={[SubHeader]}>
            <PrismicRichText
              field={subhead.richText}
              components={richTextStrongComponent}
            />
          </h3>
        </div>
        <div tw="col-span-full flex flex-col lg:(flex-row justify-center items-center)">
          {ctas.map((cta, index) => (
            <PrismicLinkInternalOrExternal
              key={index}
              field={cta.cta_link}
              trackEventParams={{
                pageTitle: pageTitle,
                path: pagePath,
                target: 'url' in cta.cta_link ? cta.cta_link.url : '',
                copy: cta.cta_text,
              }}
              cssStyle={[
                {
                  backgroundColor: bgColor,
                  '&:hover': { backgroundColor: hoverColor },
                },
                tw`border border-white text-white uppercase px-12 py-4 w-full text-[13px] font-object letter-spacing[1px] mx-auto flex justify-center items-center my-2.5 sm:max-w-[350px] lg:(w-auto mt-0 mx-3 my-0  transition-colors)`,
              ]}
            >
              {cta.cta_text}
              <InlineSvg src={ctaArrow} tw="w-6 ml-[5px] mt-[-2px] inline" />
            </PrismicLinkInternalOrExternal>
          ))}
        </div>
      </Grid>
    </section>
  )
}

export default observer(GetStarted)
